// extracted by mini-css-extract-plugin
module.exports = {"location-container--header":"_76krr","body":"-d6Eh","body-art":"qH7Jc","rc-tabs-bar":"kwGcS","rc-tabs-tab":"wTG0l","rc-tabs-tab-active":"B50hT","fieldItem":"VeEiV"};